// extracted by mini-css-extract-plugin
export default {"box":"list_box__ygB+9"};